export default __webpack_public_path__ + "static/media/resp-rate.754b6bb8.svg";